// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #fff;
  color: #333;
}

* {
  box-sizing: border-box;
}

/* App container */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex-grow: 1;
  width: 100%;
}

/* Header styles */
.header {
  display: flex;
}

.logo {
  height: 35px;
  width: auto;
}

/* Footer styles */
.footer {
  display: flex;
}

.social-icons {
  display: flex;
  gap: 0.5rem;
}

.icon-fill {
  padding: 5px;
  border-radius: 5px;
}

.btn-disabled {
  background-color: #cccccc;
  color: #666666;
  border: none;
  padding: 0.6rem 1.2rem;
  margin-left: 0.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

.btn-disabled:hover {
  background-color: #cccccc !important;
  color: #666666 !important;
}

.back-button { /*Buttons intended for close, back, home, exit functionality */
  background-color: #e0e0e0;
  color: #333;
  border: none;
  padding: 0.6rem 1.2rem;
  margin-left: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.back-button:hover {
  background-color: #a0a0a0;
}

/* Helper for labels that are visually hidden but used for layout alignment */
.sr-only-for-layout {
  visibility: hidden; /* Keeps it in layout flow but not visible */
  width: 250px; /* Match other labels */
  margin-right: 1rem;
}

textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  min-height: 100px; /* Default height for textarea */
  resize: vertical; /* Allow vertical resizing */
}

/* Error Message Styles */
.error-message {
  color: #FF0000;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  max-width: 35rem;
}

.name-errors-row {
  display: flex;
  margin-top: -1.7rem;
  padding-bottom: 1.3rem;
  padding-left: 17rem;
  gap: 0.5rem;
}

.name-error-item {
  flex: 1;
  color: #FF0000;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

/* Popup Styles */
.popup-modal {
  overflow-y: hidden;
  background: #ffffff;
  z-index: 1000;
  border: 1px solid lightgrey;
  border-radius: 12px;
  font-size: 0.9rem;
}

.popup-overlay {
  background: rgba(49,49,49,0.65);
  z-index: 999;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
}

.popup-modal > .header {
  background: #ffffff;
  width: 100%;
  border-bottom: 1px solid lightgrey;
  font-size: 18px;
  text-align: left;
  padding: 15px;
}

.popup-modal > .content {
  transform: translateZ(1px);
  z-index: 1000;
  width: 100%;
  padding: 10px 5px 0px 5px;
}

.popup-modal > .actions {
  width: 100%;
  padding: 10px 5px;
  margin: auto;
  text-align: center;
}

/* Modal Components Shared Styles */
.modal-container {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 95vw;
  max-width: 1200px;
  max-height: 85vh;
  overflow-y: auto;
}

.modal-container-wide {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 95vw;
  max-width: 1600px;
  max-height: 85vh;
  overflow-y: auto;
}

.modal-header {
  margin-bottom: 20px;
}

.modal-header h2 {
  color: #1b6aab;
  margin: 0 0 16px 0;
  font-size: 1.25rem;
  font-weight: 600;
  background: #e0f2fe;
  padding: 8px 12px;
  border-radius: 4px;
  display: inline-block;
}

.modal-header p {
  color: #374151;
  line-height: 1.5;
  margin: 0;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.modal-actions.center {
  justify-content: center;
}

.btn-danger {
  background: #dc2626;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  margin-left: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-danger:hover {
  background: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/globals.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,uGAAuG;EACvG,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,eAAe,8DAA8D;EAC3E,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB,EAAE,4CAA4C;EAChE,YAAY,EAAE,uBAAuB;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  background-color: #fff;\n  color: #333;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* App container */\n.app-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex-grow: 1;\n  width: 100%;\n}\n\n/* Header styles */\n.header {\n  display: flex;\n}\n\n.logo {\n  height: 35px;\n  width: auto;\n}\n\n/* Footer styles */\n.footer {\n  display: flex;\n}\n\n.social-icons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.icon-fill {\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.btn-disabled {\n  background-color: #cccccc;\n  color: #666666;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  margin-left: 0.5rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.btn-disabled:hover {\n  background-color: #cccccc !important;\n  color: #666666 !important;\n}\n\n.back-button { /*Buttons intended for close, back, home, exit functionality */\n  background-color: #e0e0e0;\n  color: #333;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  margin-left: 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.back-button:hover {\n  background-color: #a0a0a0;\n}\n\n/* Helper for labels that are visually hidden but used for layout alignment */\n.sr-only-for-layout {\n  visibility: hidden; /* Keeps it in layout flow but not visible */\n  width: 250px; /* Match other labels */\n  margin-right: 1rem;\n}\n\ntextarea {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  min-height: 100px; /* Default height for textarea */\n  resize: vertical; /* Allow vertical resizing */\n}\n\n/* Error Message Styles */\n.error-message {\n  color: #FF0000;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  max-width: 35rem;\n}\n\n.name-errors-row {\n  display: flex;\n  margin-top: -1.7rem;\n  padding-bottom: 1.3rem;\n  padding-left: 17rem;\n  gap: 0.5rem;\n}\n\n.name-error-item {\n  flex: 1;\n  color: #FF0000;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n/* Popup Styles */\n.popup-modal {\n  overflow-y: hidden;\n  background: #ffffff;\n  z-index: 1000;\n  border: 1px solid lightgrey;\n  border-radius: 12px;\n  font-size: 0.9rem;\n}\n\n.popup-overlay {\n  background: rgba(49,49,49,0.65);\n  z-index: 999;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n}\n\n.popup-modal > .header {\n  background: #ffffff;\n  width: 100%;\n  border-bottom: 1px solid lightgrey;\n  font-size: 18px;\n  text-align: left;\n  padding: 15px;\n}\n\n.popup-modal > .content {\n  transform: translateZ(1px);\n  z-index: 1000;\n  width: 100%;\n  padding: 10px 5px 0px 5px;\n}\n\n.popup-modal > .actions {\n  width: 100%;\n  padding: 10px 5px;\n  margin: auto;\n  text-align: center;\n}\n\n/* Modal Components Shared Styles */\n.modal-container {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  width: 95vw;\n  max-width: 1200px;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.modal-container-wide {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  width: 95vw;\n  max-width: 1600px;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  margin-bottom: 20px;\n}\n\n.modal-header h2 {\n  color: #1b6aab;\n  margin: 0 0 16px 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  background: #e0f2fe;\n  padding: 8px 12px;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.modal-header p {\n  color: #374151;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modal-actions.center {\n  justify-content: center;\n}\n\n.btn-danger {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  margin-left: 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.btn-danger:hover {\n  background: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
